import React, { useState, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faChevronRight,
  faUsers,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { commonAPI } from "../../../../services/CommonAPIService";
// import { toast } from 'react-toastify';
import ACREPR from '../../../../assets/img/roles/ACREPR.png';
import AMBUL from '../../../../assets/img/roles/AMBUL.png';
import APREPR from '../../../../assets/img/roles/APREPR.png';
import BABYST from '../../../../assets/img/roles/BABYST.png';
import BBALL from '../../../../assets/img/roles/BBALL.png';
import BEAUTY from '../../../../assets/img/roles/BEAUTY.png';
import BOUNCR from '../../../../assets/img/roles/BOUNCR.png';
import CARCLN from '../../../../assets/img/roles/CARCLN.png';
import CARPEN from '../../../../assets/img/roles/CARPEN.png';
import CCTVTC from '../../../../assets/img/roles/CCTVTC.png';
import COOK from '../../../../assets/img/roles/COOK.png';
import DANCE from '../../../../assets/img/roles/DANCE.png';
import defaultImg from '../../../../assets/img/roles/default.png';
import DOGWLK from '../../../../assets/img/roles/DOGWLK.png';
import DRIVER from '../../../../assets/img/roles/DRIVER.png';
import ELCARE from '../../../../assets/img/roles/ELCARE.png';
import ELECT from '../../../../assets/img/roles/ELECT.png';
import Electrician from '../../../../assets/img/roles/Electrician.png';
import FBALL from '../../../../assets/img/roles/FBALL.png';
import FIREOF from '../../../../assets/img/roles/FIREOF.png';
import FLOWER from '../../../../assets/img/roles/FLOWER.png';
import GARDN from '../../../../assets/img/roles/GARDN.png';
import GROC from '../../../../assets/img/roles/GROC.png';
import HAIRD from '../../../../assets/img/roles/HAIRD.png';
import INTRWR from '../../../../assets/img/roles/INTRWR.png';
import LAUNDR from '../../../../assets/img/roles/LAUNDR.png';
import MAID from '../../../../assets/img/roles/MAID.png';
import MEDSH from '../../../../assets/img/roles/MEDSH.png';
import MILKVD from '../../../../assets/img/roles/MILKVD.png';
import MUSIC from '../../../../assets/img/roles/MUSIC.png';
import NANNY from '../../../../assets/img/roles/NANNY.png';
import NEWSDP from '../../../../assets/img/roles/NEWSDP.png';
import NURSE from '../../../../assets/img/roles/NURSE.png';
import PAINT from '../../../../assets/img/roles/PAINT.png';
import PESTCT from '../../../../assets/img/roles/PESTCT.png';
import PHOTO from '../../../../assets/img/roles/PHOTO.png';
import PHYSIO from '../../../../assets/img/roles/PHYSIO.png';
import PLUMB from '../../../../assets/img/roles/PLUMB.png';
import ROWATR from '../../../../assets/img/roles/ROWATR.png';
import SKATE from '../../../../assets/img/roles/SKATE.png';
import STAFF from '../../../../assets/img/roles/STAFF.png';
import TAEK from '../../../../assets/img/roles/TAEK.png';
import TAILR from '../../../../assets/img/roles/TAILR.png';
import TENNIS from '../../../../assets/img/roles/TENNIS.png';
import TUTION from '../../../../assets/img/roles/TUTION.png';
import VEGVEN from '../../../../assets/img/roles/VEGVEN.png';
import WTCLNR from '../../../../assets/img/roles/WTCLNR.png';
import YOGA from '../../../../assets/img/roles/YOGA.png';

const UpdateAddStaffModal = ({ show, onClose, staffId, currentRoleId, onSuccess }) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const roleIcons = {
    ACREPR,
    AMBUL,
    APREPR,
    BABYST,
    BBALL,
    BEAUTY,
    BOUNCR,
    CARCLN,
    CARPEN,
    CCTVTC,
    COOK,
    DANCE,
    DOGWLK,
    DRIVER,
    ELCARE,
    ELECT,
    Electrician,
    FBALL,
    FIREOF,
    FLOWER,
    GARDN,
    GROC,
    HAIRD,
    INTRWR,
    LAUNDR,
    MAID,
    MEDSH,
    MILKVD,
    MUSIC,
    NANNY,
    NEWSDP,
    NURSE,
    PAINT,
    PESTCT,
    PHOTO,
    PHYSIO,
    PLUMB,
    ROWATR,
    SKATE,
    STAFF,
    TAEK,
    TAILR,
    TENNIS,
    TUTION,
    VEGVEN,
    WTCLNR,
    YOGA,
    default: defaultImg,
  };

  // Search state
  const [searchTerm, setSearchTerm] = useState("");

const myUserData = useMemo(() => {
  try {
    const auth = localStorage.getItem("userData");
    return auth ? JSON.parse(auth) : null;
  } catch (err) {
    console.error("Invalid userData in localStorage", err);
    return null;
  }
}, []);

 const fetchData = async () => {
  if (!myUserData) return;

  setLoading(true);
  setError(null);
  setSelectedDepartment(null);
  setSearchTerm("");

  try {
    const response = await commonAPI("Department", undefined, {
      buildingId: myUserData?.buildingId,
    });

    if (response?.success === true) {
      setDepartments(response.data || []);
    } else {
      setError(response?.message || "Failed to load departments");
    }
  } catch (err) {
    console.error("Fetch departments error:", err);

    const bodyError = {
      userId: myUserData?.userId,
      mobileNumber: myUserData?.mobileNumber,
      requestJSON: null,
      uri: "/api/Master/Department",
      errorSource: "CuroNextPortal",
      errorNumber: "UPDSTF01",
      errorSummary: err?.message,
      errorDescription: err?.message,
      fileClassName: "UpdateAddStaffModal.js",
      functionName: "fetchData",
    };

    try {
      await commonAPI("ErrorLogMaster", bodyError);
    } catch (logErr) {
      console.error("Error while logging error:", logErr);
    }

    setError("Error loading departments and roles");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    if (show) {
      fetchData();
    }
  }, [show]);

  if (!show) return null;

  
  // Filter logic

  const lowerSearch = searchTerm.toLowerCase().trim();


  const frequentRoles = departments
    .flatMap((dept) => dept.roles || [])
    .filter((role) => role.isFrequent === true);

  const filteredFrequentRoles = lowerSearch
    ? frequentRoles.filter((role) =>
        role.roleName?.toLowerCase().includes(lowerSearch)
      )
    : frequentRoles.slice(0, 8);

  
  const selectedDeptRoles = selectedDepartment
    ? departments.find((d) => d.departmentId === selectedDepartment.departmentId)?.roles || []
    : [];

  const filteredDeptRoles = lowerSearch
    ? selectedDeptRoles.filter((role) =>
        role.roleName?.toLowerCase().includes(lowerSearch)
      )
    : selectedDeptRoles;

  const filteredDepartments = lowerSearch
    ? departments.filter((dept) =>
        dept.departmentName?.toLowerCase().includes(lowerSearch)
      )
    : departments;

  const hasSearch = lowerSearch.length > 0;

const handleRoleClick = async (role) => {
  if (!myUserData) return;
  if (!staffId) return;

  const payload = {
    staffId: staffId,
    value: {
      RoleId: String(role.roleId),
    },
    modifiedUserId: String(staffId),
    key: "PERSONALINFO",
  };

  try {
    setLoading(true);

    const response = await commonAPI(
      "UpdateServiceStaffDetail",
      payload,
      { buildingId: myUserData?.buildingId }
    );

    if (response?.success === true) {
      window.toast.success("Service type updated successfully");
      onSuccess?.();
      onClose?.();
    } else {
      window.toast.error(response?.message || "Failed to update service type");
    }

  } catch (error) {
    console.error("Error updating service type:", error);

    const bodyError = {
      userId: myUserData?.userId,
      mobileNumber: myUserData?.mobileNumber,
      requestJSON: JSON.stringify(payload),
      uri: "/api/User/ServiceStaffV1",
      errorSource: "CuroNextPortal",
      errorNumber: "UPDSTF02",
      errorSummary: error?.message,
      errorDescription: error?.message,
      fileClassName: "AddStaffModal.js",
      functionName: "handleRoleClick",
    };

    try {
      await commonAPI("ErrorLogMaster", bodyError);
    } catch (logErr) {
      console.error("Error while logging error:", logErr);
    }

    window.toast.error("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <div className="modal fade show" style={{ display: "block", zIndex: 1500 }} tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content rounded-3 shadow border-0">
            <div className="modal-header  text-white border-0 px-4 py-3" style={{background:"#1C80D2"}}>
              <h5 className="modal-title fw-bold fs-5">
                {selectedDepartment ? selectedDepartment.departmentName : "Add Staff"}
              </h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>

            <div className="modal-body p-4 bg-white" style={{ maxHeight: "75vh", overflowY: "auto" }}>
              {/* Search Input – now active */}
              <div className="input-group mb-4 shadow-sm rounded-pill overflow-hidden">
                <span className="input-group-text bg-white border-0 ps-4 pe-2">
                  <FontAwesomeIcon icon={faSearch} className="text-muted" />
                </span>
                <input
                  type="text"
                  className="form-control border-0 py-3 fs-6"
                  placeholder="Search Categories"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {loading ? (
                <div className="text-center my-5">
                  <div className="spinner-border text-primary" role="status" />
                </div>
              ) : error ? (
                <div className="alert alert-danger text-center">{error}</div>
              ) : (
                <>
                  {/* Frequently Used */}
                  {!selectedDepartment && !hasSearch && filteredFrequentRoles.length > 0 && (
                    <>
                      <h6 className="fw-bold text-uppercase text-muted small mb-3">Frequently Used</h6>
                      <div className="row g-3 mb-5">
                        {filteredFrequentRoles.map((role, idx) => (
                          <div key={idx} className="col-6 col-sm-4 col-md-3">
                            <div
                              className="card border-0 shadow-sm text-center py-3 h-100"
                              style={{ cursor: "pointer", borderRadius: "12px" }}
                              onClick={() => handleRoleClick(role)}
                            >
                              {role.imageIconURL ? (
                                <img
                                  src={roleIcons[role.imageIconURL] || roleIcons.default}
                                  alt={role.roleName}
                                  style={{ width: "48px", height: "48px", margin: "0 auto 12px", objectFit: "contain" }}
                                />
                              ) : (
                                <FontAwesomeIcon icon={faUsers} size="2x" className="text-primary mb-3" />
                              )}
                              <div className="small fw-medium">{role.roleName}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}

                  {/* Back button + Title */}
                  <div className="d-flex align-items-center mb-3">
                    {selectedDepartment && (
                      <button
                        className="btn btn-link text-muted p-0 me-3"
                        onClick={() => {
                          setSelectedDepartment(null);
                          setSearchTerm(""); 
                        }}
                        style={{ fontSize: "1.1rem" }}
                      >
                        <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                        Back
                      </button>
                    )}
                    <h6 className="fw-bold text-uppercase text-muted small m-0">
                      {selectedDepartment ? "Roles" : "Categories"}
                    </h6>
                  </div>

                  {/* Content – filtered */}
                  {selectedDepartment ? (
                    <>
                      {filteredDeptRoles.length > 0 ? (
                        <div className="list-group border-0 rounded-3 overflow-hidden shadow-sm">
                          {filteredDeptRoles.map((role, idx) => (
                            <button
                              key={idx}
                              className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 px-4"
                              onClick={() => handleRoleClick(role)}
                            >
                              <div className="d-flex align-items-center">
                                {role.imageIconURL ? (
                                  <img
                                    src={roleIcons[role.imageIconURL] || roleIcons.default}
                                    alt={role.roleName}
                                    style={{ width: "32px", height: "32px", marginRight: "16px", objectFit: "contain" }}
                                  />
                                ) : (
                                  <FontAwesomeIcon icon={faUsers} className="me-3 text-primary" size="lg" />
                                )}
                                <span className="fw-medium">{role.roleName}</span>
                              </div>
                              <FontAwesomeIcon icon={faChevronRight} className="text-muted" />
                            </button>
                          ))}
                        </div>
                      ) : (
                        <div className="alert alert-info text-center m-3">
                          {hasSearch ? "No matching roles found" : "No roles in this category"}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {filteredDepartments.length > 0 ? (
                        <div className="list-group border-0 rounded-3 overflow-hidden shadow-sm">
                          {filteredDepartments.map((dept, idx) => (
                            <button
                              key={idx}
                              className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 px-4"
                              onClick={() => setSelectedDepartment(dept)}
                            >
                              <div className="d-flex align-items-center">
                                {dept.imageIconURLDept ? (
                                  <img
                                    src={roleIcons[dept.imageIconURLDept] || roleIcons.default}
                                    alt={dept.departmentName}
                                    style={{ width: "32px", height: "32px", marginRight: "16px", objectFit: "contain" }}
                                  />
                                ) : (
                                  <FontAwesomeIcon icon={faUsers} className="me-3 text-primary" size="lg" />
                                )}
                                <span className="fw-medium">{dept.departmentName}</span>
                              </div>
                              <FontAwesomeIcon icon={faChevronRight} className="text-muted" />
                            </button>
                          ))}
                        </div>
                      ) : (
                        <div className="alert alert-info text-center m-3">
                          {hasSearch ? "No matching categories found" : "No departments available"}
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} onClick={onClose} />
    </>
  );
};

export default UpdateAddStaffModal;